// import { Divider } from "@mui/material";
// import React from "react";
// import {
//   sumCartItemMrpPrice,
//   sumCartItemSellingPrice,
// } from "../../../util/cartCalculator";
// import { useAppSelector } from "../../../Redux Toolkit/Store";

// const PricingCard = ({ showBuyButton, SubmitButton }: any) => {
//   const { cart } = useAppSelector((store) => store);

//   const totalSellingPrice = cart.cart?.totalSellingPrice || 0;
//   const cartItems = cart.cart?.cartItems || [];
//   const cartItemsCount = cartItems.length;

//   const FREE_SHIPPING_LIMIT = 999;
//   const SHIPPING_FEE = 70;

//   const isFreeShipping = totalSellingPrice >= FREE_SHIPPING_LIMIT;
//   const shippingFee = isFreeShipping ? 0 : SHIPPING_FEE;
//   const finalTotal = totalSellingPrice + shippingFee;

//   const totalSavings =
//     sumCartItemMrpPrice(cartItems) - sumCartItemSellingPrice(cartItems);

//   return (
//     <div>
//       <div className="space-y-4 p-5">
//         <h2 className="text-lg font-semibold">Order Summary</h2>

//         <div className="flex justify-between items-center">
//           <span>Subtotal ({cartItemsCount} {cartItemsCount === 1 ? "item" : "items"})</span>
//           <span className="font-semibold">₹{totalSellingPrice}</span>
//         </div>

//         <div className="flex justify-between items-center">
//           <span>Shipping</span>
//           <span className={isFreeShipping ? "text-teal-600 font-medium" : ""}>
//             {isFreeShipping ? "Free" : "₹70"}
//           </span>
//         </div>

//         <div className="flex justify-between items-center">
//           <span>Platform Fee</span>

//           <span className="text-green-600 font-medium">
//             ₹0
//           </span>
//         </div>

//         <div className="pt-2">
//           {totalSellingPrice < 999 ? (
//             <>
//               <div className="flex justify-between items-center text-sm mb-2">
//                 <span className="font-medium">
//                   You are ₹{999 - totalSellingPrice} away from free shipping!
//                 </span>

//                 <span className="font-semibold">
//                   ₹{999 - totalSellingPrice} to go
//                 </span>
//               </div>

//               <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
//                 <div
//                   className={`h-full rounded-full transition-all duration-500 ${totalSellingPrice >= 1499
//                     ? "bg-green-600"
//                     : "bg-gray-800"
//                     }`}
//                   style={{
//                     width: `${Math.min(
//                       (totalSellingPrice / 1499) * 100,
//                       100
//                     )}%`,
//                   }}
//                 />
//               </div>
//             </>
//           ) : (
//             <div className="text-sm font-medium text-teal-600">
//               You are eligible for free shipping
//             </div>
//           )}
//         </div>

//         <Divider />

//         <div className="flex justify-between items-center font-semibold text-base">
//           <span>Total</span>
//           <span>₹{finalTotal}</span>
//         </div>

//         <div className="flex justify-between items-center text-sm">
//           <span>Total savings</span>
//           <span className="text-teal-700 font-medium">
//             {totalSavings > 0 ? `₹${totalSavings}` : "—"}
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PricingCard;



import { Divider } from "@mui/material";
import React from "react";
import {
  sumCartItemMrpPrice,
  sumCartItemSellingPrice,
} from "../../../util/cartCalculator";
import { useAppSelector } from "../../../Redux Toolkit/Store";

const PricingCard = ({ showBuyButton, SubmitButton }: any) => {
  const { cart } = useAppSelector((store) => store);

  const totalSellingPrice = cart.cart?.totalSellingPrice || 0;
  const cartItems = cart.cart?.cartItems || [];
  const cartItemsCount = cartItems.length;

  const couponDiscount = cart.cart?.couponPrice || 0;
  const couponCode = cart.cart?.couponCode;

  const isFreeShipping = totalSellingPrice > 999;
  const shippingFee = isFreeShipping ? 0 : 70;
  const finalTotal = totalSellingPrice + shippingFee;

  const productSavings =
    sumCartItemMrpPrice(cartItems) - sumCartItemSellingPrice(cartItems);

  const totalSavings = productSavings + couponDiscount;

  return (
    <div>
      <div className="space-y-4 p-5">
        <h2 className="text-lg font-semibold">Order Summary</h2>

        <div className="flex justify-between items-center">
          <span>
            Subtotal ({cartItemsCount} {cartItemsCount === 1 ? "item" : "items"})
          </span>
          <span className="font-semibold">₹{sumCartItemSellingPrice(cartItems)}</span>
        </div>

        {couponDiscount > 0 && (
          <div className="flex justify-between items-center text-sm text-green-600 font-medium">
            <span>
              Coupon Discount
              {couponCode ? (
                <span className="text-gray-500"> ({couponCode})</span>
              ) : null}
            </span>

            <span className="text-teal-700 font-medium">
              -₹{couponDiscount}
            </span>
          </div>
        )}

        <div className="flex justify-between items-center">
          <span>Shipping</span>
          <span className={isFreeShipping ? "text-teal-600 font-medium" : ""}>
            {isFreeShipping ? "Free" : "₹70"}
          </span>
        </div>

        <div className="flex justify-between items-center">
          <span>Platform Fee</span>

          <span className="text-green-600 font-medium">₹0</span>
        </div>

        <div className="pt-2">
          {totalSellingPrice < 999 ? (
            <>
              <div className="flex justify-between items-center text-sm mb-2">
                <span className="font-medium">
                  You are ₹{999 - totalSellingPrice} away from free shipping!
                </span>

                <span className="font-semibold">
                  ₹{999 - totalSellingPrice} to go
                </span>
              </div>

              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${
                    totalSellingPrice >= 999 ? "bg-green-600" : "bg-gray-800"
                  }`}
                  style={{
                    width: `${Math.min((totalSellingPrice / 999) * 100, 100)}%`,
                  }}
                />
              </div>
            </>
          ) : (
            <div className="text-sm font-medium text-teal-600">
              You are eligible for free shipping
            </div>
          )}
        </div>

        <Divider />

        <div className="flex justify-between items-center font-semibold text-base">
          <span>Total</span>
          <span>₹{finalTotal}</span>
        </div>

        <div className="flex justify-between items-center text-sm text-green-600 font-medium">
          <span>Total savings</span>
          <span>
            {totalSavings > 0 ? `₹${totalSavings}` : "—"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;